export const getInitialState = () => ({
	visits: null,
	areInstructionsVisible: true,
	pagination: {
		currentPage: 0
	},
	features: null,
	counters: null
});
